import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ThemeToggle } from "./ThemeToggle";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const navLinks = [
    { href: "#flow", label: "How it works" },
    { href: "#pricing", label: "Pricing" },
  ];

  const scrollToSection = (href: string) => {
    setOpen(false);
    const element = document.querySelector(href);
    element?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav className="sticky top-0 z-50 glass border-b border-border/50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-14 sm:h-16">
          {/* Logo - text only */}
          <div 
            className="cursor-pointer shrink-0" 
            onClick={() => navigate("/")}
          >
            <span className="font-bold text-lg sm:text-xl tracking-tight">Strata</span>
          </div>

          {/* Desktop Navigation - center */}
          <div className="hidden md:flex items-center gap-6 lg:gap-8">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollToSection(link.href)}
                className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors touch-target"
              >
                {link.label}
              </button>
            ))}
          </div>

          {/* Desktop Actions */}
          <div className="hidden md:flex items-center gap-2 sm:gap-3">
            <ThemeToggle />
            <Button 
              variant="ghost" 
              className="text-muted-foreground hover:text-foreground touch-target"
              onClick={() => navigate("/auth")}
            >
              Open Strata
            </Button>
          </div>

          {/* Mobile Menu */}
          <div className="flex md:hidden items-center gap-1 sm:gap-2">
            <ThemeToggle />
            <Sheet open={open} onOpenChange={setOpen}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon" className="touch-target" aria-label="Open navigation menu">
                  <Menu className="h-5 w-5" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-[280px] sm:w-72 pt-12">
                <div className="flex flex-col gap-6">
                  <div className="flex flex-col gap-4">
                    {navLinks.map((link) => (
                      <button
                        key={link.href}
                        onClick={() => scrollToSection(link.href)}
                        className="text-left text-lg font-medium text-foreground hover:text-primary transition-colors py-2 touch-target"
                      >
                        {link.label}
                      </button>
                    ))}
                  </div>
                  <div className="border-t pt-6">
                    <Button 
                      className="w-full justify-center h-12 touch-target"
                      onClick={() => {
                        setOpen(false);
                        navigate("/auth");
                      }}
                    >
                      Open Strata
                    </Button>
                  </div>
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </nav>
  );
};
